<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Penilaian Siswa'">
          <template v-slot:body>
            <b-tabs content-class="mt-3">
              <b-tab title="Penilaian per Mata Kuliah" active>
                <PenilaianMataKuliah />
              </b-tab>
              <b-tab title="Penilaian Akademik">
                <PenilaianAkademikMatkul />
              </b-tab>
              <b-tab title="Penilaian Jasmani">
                <PenilaianJasmani />
              </b-tab>
              <b-tab title="Hasil Penilaian Sosiometri">
                <PenilaianSosiometri />
              </b-tab>
              <b-tab title="Hasil Nilai Akademik">
                <PenilaianAkademik />
              </b-tab>
              <b-tab title="Penilaian Kepribadian">
                <PenilaianKepribadian />
              </b-tab>
            </b-tabs>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PenilaianJasmani from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianJasmani.vue';
import PenilaianSosiometri from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianSosiometri.vue';
import PenilaianAkademik from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianAkademik.vue';
import PenilaianMataKuliah from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianMataKuliah.vue';
import PenilaianAkademikMatkul from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianAkademikMatkul.vue';
import PenilaianKepribadian from '@/view/pages/penilaian-pasis/tab_master_penilaian/PenilaianKepribadian.vue';

export default {
  name: 'KALDIK',
  components: {
    KTCodePreview,
    PenilaianJasmani,
    PenilaianSosiometri,
    PenilaianAkademik,
    PenilaianMataKuliah,
    PenilaianAkademikMatkul,
    PenilaianKepribadian
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Penilaian Siswa" },
      { title: "Master Penilaian" }
    ]);
  }
}
</script>